/**
 * peacohrm is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 peacohrm Inc., http://www.peacohrm.com
 *
 * peacohrm is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * peacohrm is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import ClaimEvent from '@/peacohrmClaimPlugin/pages/ClaimEvent.vue';
import SaveClaimEvent from '@/peacohrmClaimPlugin/pages/SaveClaimEvent.vue';
import EditClaimEvent from '@/peacohrmClaimPlugin/pages/EditClaimEvent.vue';
import ClaimExpenseType from '@/peacohrmClaimPlugin/pages/claimExpenseTypes/ClaimExpenseType.vue';
import SaveClaimExpenseType from '@/peacohrmClaimPlugin/pages/claimExpenseTypes/SaveClaimExpenseType.vue';
import EditClaimExpenseType from '@/peacohrmClaimPlugin/pages/claimExpenseTypes/EditClaimExpenseType.vue';
import SubmitClaimRequest from '@/peacohrmClaimPlugin/pages/submitClaim/SubmitClaimRequest.vue';
import SubmitClaim from '@/peacohrmClaimPlugin/pages/submitClaim/SubmitClaim.vue';
import MyClaims from '@/peacohrmClaimPlugin/pages/myClaims/MyClaims.vue';
import AssignClaimRequest from '@/peacohrmClaimPlugin/pages/assignClaim/AssignClaimRequest.vue';
import AssignClaim from '@/peacohrmClaimPlugin/pages/assignClaim/AssignClaim.vue';
import EmployeeClaims from '@/peacohrmClaimPlugin/pages/employeeClaims/EmployeeClaims.vue';
import EmployeeAdvance from '@/peacohrmClaimPlugin/pages/employeeAdvance/EmployeeAdvance.vue';
import EmployeeAdvanceRequest from '@/peacohrmClaimPlugin/pages/employeeAdvance/EmployeeAdvanceRequest.vue';
import EditEmployeeAdvanceRequest from '@/peacohrmClaimPlugin/pages/employeeAdvance/EditEmployeeAdvanceRequest.vue';
import MyEmployeeAdvance from '@/peacohrmClaimPlugin/pages/employeeAdvance/MyEmployeeAdvance.vue';
import EditMyEmployeeAdvanceRequest from '@/peacohrmClaimPlugin/pages/employeeAdvance/EditMyEmployeeAdvanceRequest.vue';
import ViewMyEmployeeAdvanceRequest from '@/peacohrmClaimPlugin/pages/employeeAdvance/ViewMyEmployeeAdvanceRequest.vue';

export default {
  'reimbursement-event': ClaimEvent,
  'reimbursement-event-create': SaveClaimEvent,
  'reimbursement-event-edit': EditClaimEvent,
  'reimbursement-expense-types': ClaimExpenseType,
  'reimbursement-expense-type-create': SaveClaimExpenseType,
  'reimbursement-expense-type-edit': EditClaimExpenseType,
  'submit-reimbursement-request': SubmitClaimRequest,
  'submit-reimbursement': SubmitClaim,
  'my-reimbursement': MyClaims,
  'assign-reimbursement-request': AssignClaimRequest,
  'assign-reimbursement': AssignClaim,
  'employee-reimbursement': EmployeeClaims,
  'employee-advance': EmployeeAdvance,
  'employee-advance-request': EmployeeAdvanceRequest,
  'edit-employee-advance': EditMyEmployeeAdvanceRequest,
  'my-employee-advance': MyEmployeeAdvance,
  'employee_advance_request': EditEmployeeAdvanceRequest,
  'view-my-employee-advance': ViewMyEmployeeAdvanceRequest
};